(function () {
  // 1. Helpers: Get and Set Cookies
  function setAffCookie(name, value) {
    if (!value) return;
    let date = new Date();
    date.setTime(date.getTime() + 60 * 24 * 60 * 60 * 1000); // Set to 60 days
    document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
  }

  function getAffCookie(name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // 2. Logic: URL takes priority (Last-Click), then fallback to Cookie
  const params = new URLSearchParams(window.location.search);

  const aid = params.get('aid') || getAffCookie('my_aid');
  const hotid = params.get('hotid') || getAffCookie('my_hotid');
  const utm = params.get('utm_campaign') || getAffCookie('my_utm');
  const subid = params.get('sub_id') || getAffCookie('my_subid');

  // 3. If any data exists, sync it
  if (aid) {
    // Update/Refresh cookies (Last-Click wins)
    setAffCookie('my_aid', aid);
    setAffCookie('my_hotid', hotid);
    setAffCookie('my_utm', utm);
    setAffCookie('my_subid', subid);

    // Update Shopify Cart Attributes
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Affiliate ID': aid,
          HotID: hotid,
          Campaign: utm,
          'Sub ID': subid,
        },
      }),
    })
      .catch((err) => console.error('Cart update error:', err));
  }
})();
